////////////////////////////////////////////////////////////
//                                                        //
//  Program: CancellationPolicy.jsx                       //
//  Application: OHAI HTML                                //
//  Option: Cancellation Policy                           //
//  Developer: PS                                         //
//  Date: 2025-09-25                                      //
//                                                        //
////////////////////////////////////////////////////////////

import React, { Component } from "react";
import CmsDataService from "../../services/CmsDataService";
import CommonHeader from "../common/CommonHeader";
import CommonFooter from "../common/CommonFooter";
import queryString from "query-string";
import MetaSEO from "../../../MetaSEO";
import CommonFooterNav from "../common/CommonFooterNav";
const queryParams = queryString.parse(location.search);
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
class CancellationPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      personName: [],
      date: new Date('2014-08-18T21:11:54'),
      selectedDate: new Date(),
      type: false,
      value: undefined,
      inputValue: undefined,
      input: {},
      errors: {},
      first_name: "",
      last_name: "",
      email: "",
      phone_number: "",
      applicant_photo: "",
      price_range: "",
      desired_move_in_date: "",
      comment: "",
      status_id: true,
      helperText: "",
      bedroom: [],
      bedroomArray: [],
      priceRangeArray: [],
      // meta tags start
      title: "",
      favicon: "",
      keywords:global.keywords,
      description:global.description,
      url:window.location.origin,
      image: "",
      fb_app_id:"",
      // meta tags end
      view: queryParams.view === "mobile" ? false : ( props.view ? false : true ),
      seoLoaded: false,
    }
  }

  componentDidMount() {
    this.getcmsCommonData();
    this.getMetaData();
  }

  getcmsCommonData = async (queryString = "") => {

    this.setState({ showSpinner: true, loading: true });
    var resData = {};
    var resDataArr = [];
    let levelSlug = global.level === 2 ? global.brandSlug : (global.level === 3 ? this.state.property_slug : 1);
    var cacheKeyName = global.level + "_CANCELLATION_POLICY_" + levelSlug;
    if (global.LocalStorageManage.getWithExpiry(cacheKeyName) !== null) {
      var data = global.LocalStorageManage.getWithExpiry(cacheKeyName) !== null ? JSON.parse(global.LocalStorageManage.getWithExpiry(cacheKeyName)) : localStorage.removeItem(cacheKeyName);
      this.setState(data);
    }
    let res = await CmsDataService.getCmsData("CANCELLATION_POLICY", 1, 1);
    if (global.successStatus.includes(res.status)) {
      resDataArr = res.data ? res.data : [];
      resDataArr.map((item, key) => {
        resData[item.section_name_slug] = item.section_data;
      });
    }
    await this.setState({
      showSpinner: false,
      loading: false
    });
    global.LocalStorageManage.setWithExpiry(cacheKeyName, JSON.stringify(resData));
    this.setState(resData);

  };

  getMetaData = async () => {
    this.setState({ showSpinner: true, loading: true });
    var resData = {};
    var resDataArr = [];
    var cacheKeyName = global.level + "_CANCELLATION_POLICY_META_DATA_";
    if (global.LocalStorageManage.getWithExpiry(cacheKeyName) !== null) {
      var data = global.LocalStorageManage.getWithExpiry(cacheKeyName) !== null ? JSON.parse(global.LocalStorageManage.getWithExpiry(cacheKeyName)) : localStorage.removeItem(cacheKeyName);
      this.setState(data);
    }
    let levelSlug = global.level === 2 ? global.brandSlug : (global.level === 3 ? this.state.property_slug : 1);
    let res = await CmsDataService.getCmsMetaData("CANCELLATION_POLICY", global.level, levelSlug);
    if (global.successStatus.includes(res.status)) {
      resData.title = res.data ? (res.data.meta_data &&  res.data.meta_data.META ? res.data.meta_data.META.title : "" ) : "";
      resData.favicon = res.data ? (res.data.meta_data &&  res.data.meta_data.META ? res.data.meta_data.META.favicon_url : "" ) : "";
      resData.keywords = res.data ? (res.data.meta_data &&  res.data.meta_data.META ? res.data.meta_data.META.keywords : "" ) : "";
      resData.description = res.data ? (res.data.meta_data &&  res.data.meta_data.META ? res.data.meta_data.META.description : "" ) : "";
      resData.url = res.data ? (res.data.meta_data &&  res.data.meta_data.META ? res.data.meta_data.META.favicon_url : "" ) : "";
      resData.image = res.data ? (res.data.meta_data &&  res.data.meta_data.META ? res.data.meta_data.META.favicon_url : "" ) : "";
      resData.fb_app_id = res.data ? (res.data.meta_data &&  res.data.meta_data.META ? res.data.meta_data.META.fb_app_id : "" ) : "";
    }
    global.LocalStorageManage.setWithExpiry(cacheKeyName, JSON.stringify(resData));
    this.setState(resData);
    await this.setState({
      showSpinner: false,
      loading: false,
      seoLoaded: true
    });
  }

  render() {
    return (
      <main className="oh-template Brandmainpage">
        {/* Meta Tag Start */}
        {
          this.state.seoLoaded &&
            <MetaSEO
                title = {this.state.title}
                favicon = {this.state.favicon}
                keywords = {this.state.keywords}
                description = {this.state.description}
                noIndex={"true"}
                url = {this.state.url}
                image = {this.state.image}
                fb_app_id = {this.state.fb_app_id}
            />
         }
        {/* Meta Tag End */}
        {/* Header */}
        {this.state.view &&
          <CommonHeader propertySlug={this.state.property_slug} />
        }
        {/* middle */}
        <section className="middle">
          <div className="container disclaim_sec privacy_sec">
            {/* new logic */}
            {this.state.view &&
              <section className="reservationBook ">
                <span className="pry_mob_head">{(this.state.CANCELLATION_POLICY_SECTION_1 && this.state.CANCELLATION_POLICY_SECTION_1[0]) ? this.state.CANCELLATION_POLICY_SECTION_1[0].text : "Cancellation Policy"}</span>
              </section>
            }
            <div className="newcontentPrivacy">
            { (this.state.CANCELLATION_POLICY_SECTION_1 && this.state.CANCELLATION_POLICY_SECTION_1[1])
              ?
              <div
                dangerouslySetInnerHTML={{__html: this.state.CANCELLATION_POLICY_SECTION_1[1].text}}
              />
            :
              <>
                <p className={!this.state.view ? "text-justify f-sz-12" : "text-justify"}>At OrionHaus, we want to be upfront and clear about what happens if you need to cancel your reservation. Please read the terms below before completing your booking. By confirming a reservation, you agree to this Cancellation Policy.</p>
                <p className={!this.state.view ? "text-justify f-sz-12" : "text-justify"}><strong>VOUCHER BOOKINGS &mdash; FINAL SALE</strong></p>
                <p className={!this.state.view ? "text-justify f-sz-12" : "text-justify"}>Reservations made using a voucher are considered final at the time of booking. Voucher bookings are not eligible for a refund.</p>
                <p className={!this.state.view ? "text-justify f-sz-12" : "text-justify"}><strong>STANDARD CANCELLATION TERMS</strong></p>
                <p className={!this.state.view ? "text-justify f-sz-12" : "text-justify"}>For all reservations not made using a voucher, the following terms apply:</p>
                <ol>
                  <li className={!this.state.view ? "text-justify f-sz-12 p-bottom-5" : "text-justify"}>
                    <span className={!this.state.view ? "text-justify f-sz-12 termsandpolicy-m-b-5" : "text-justify"}>1. 24-Hour Grace Period &mdash; Full Refund</span>
                    <p className={!this.state.view ? "text-justify f-sz-12" : "text-justify"}>You may cancel for a full refund of all charges, including taxes, if both of the following conditions are met at the time of your cancellation:</p>
                    <ol type="a">
                      <li className={!this.state.view ? "text-justify f-sz-12 p-bottom-5" : "text-justify"}>
                        <p className={!this.state.view ? "text-justify f-sz-12" : "text-justify"}>Your cancellation is submitted within 24 hours of your original booking confirmation, AND</p>
                      </li>
                      <li className={!this.state.view ? "text-justify f-sz-12 p-bottom-5" : "text-justify"}>
                        <p className={!this.state.view ? "text-justify f-sz-12" : "text-justify"}>Your scheduled check-in date is at least 7 days away.</p>
                      </li>
                    </ol>
                    <p className={!this.state.view ? "text-justify f-sz-12" : "text-justify"}>Both conditions must be satisfied. If your check-in is fewer than 7 days away at the time of booking, the 24-hour grace period does not apply.</p>
                  </li>
                  <li className={!this.state.view ? "text-justify f-sz-12 p-bottom-5" : "text-justify"}>
                    <span className={!this.state.view ? "text-justify f-sz-12 termsandpolicy-m-b-5" : "text-justify"}>2. Cancellation 30 or More Days Before Check-In</span>
                    <p className={!this.state.view ? "text-justify f-sz-12" : "text-justify"}>If you cancel 30 or more days before your scheduled check-in date, and your cancellation falls outside the 24-hour grace period above, you will receive a refund of 50% of the accommodation charges. Applicable taxes will be refunded in full.</p>
                  </li>
                  <li className={!this.state.view ? "text-justify f-sz-12 p-bottom-5" : "text-justify"}>
                    <span className={!this.state.view ? "text-justify f-sz-12 termsandpolicy-m-b-5" : "text-justify"}>3. Cancellation Fewer Than 30 Days Before Check-In</span>
                    <p className={!this.state.view ? "text-justify f-sz-12" : "text-justify"}>If you cancel fewer than 30 days before your scheduled check-in date, and your cancellation falls outside the 24-hour grace period above, no refund will be issued for the accommodation charges. Applicable taxes collected will be refunded on a pro-rated basis.</p>
                  </li>
                </ol>
              </>
            }
            </div>
          </div>
        </section >
        {/* Footer */}
        {
          this.state.view &&
          <React.Fragment>
            <CommonFooter showSubscribe={true} showFooterBottom={false}/>
              <footer className="footer-nav-sec pt-80">
                <CommonFooterNav />
              </footer>
            <CommonFooter showSubscribe={false} showFooterBottom={true} />
          </React.Fragment>
        }
      </main >
    );
  }
}
export default CancellationPolicy
